import gql from 'graphql-tag'

export const CONTACT_EMAIL_ADDRESS_CREATE_MUTATION = gql`
    mutation contactEmailAddressCreate(
        $contact_id: ID!
        $emailAddress: EmailAddressInput!
    ) {
        contactEmailAddressCreate(
            contact_id: $contact_id
            emailAddress: $emailAddress
        ) {
            id
            category {
                id
                name
            }
            label {
                id
                label
            }
            email
            is_main_email_address
        }
    }
`
